import React from 'react';
import clsx from 'clsx';
import ClickAwayListener from 'react-click-away-listener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { ExpandableSelectorList } from '../UI/V3/ExpandableSelector/List/ExpandableSelectorList';
import { ExpandableSelectorItem } from '../UI/V3/ExpandableSelector/List/ExpandableSelectorItem';
import styles from './FilterDropdown.module.scss';

interface Option {
    id: string;
    name: string;
}

interface FilterDropdownProps {
    id: string;
    label: string;
    icon?: any;
    options: Option[];
    selectedOptionId: string;
    expanded: boolean;
    onToggle: () => void;
    onClose: () => void;
    onSelect: (id: string) => void;
    className?: string; // Appended to wrapper
    classNameList?: string;
    dropdownAlign?: 'left' | 'right';
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
    label,
    icon,
    options,
    selectedOptionId,
    expanded,
    onToggle,
    onClose,
    onSelect,
    className,
    classNameList,
    dropdownAlign = 'left'
}) => {
    return (
        <ClickAwayListener onClickAway={() => expanded && onClose()}>
            <div className={clsx(styles.filterDropdownWrapper, className)}>
                <div
                    className={clsx(styles.dropdownPill, expanded && styles.expanded)}
                    onClick={onToggle}
                >
                    <div className={styles.labelSection}>
                        {icon && (
                            <FontAwesomeIcon
                                icon={icon}
                                className={styles.iconElement}
                            />
                        )}
                        <span className={styles.labelText}>{label}</span>
                    </div>
                    <FontAwesomeIcon
                        icon={expanded ? faChevronUp : faChevronDown}
                        className={styles.chevronIcon}
                    />
                </div>

                {expanded && (
                    <div className={clsx(styles.dropdownMenu, dropdownAlign === 'right' && styles.alignRight)}>
                        <ExpandableSelectorList
                            onItemSelected={onClose}
                            className={classNameList}
                        >
                            {options.map(option => (
                                <ExpandableSelectorItem
                                    key={option.id}
                                    selected={option.id === selectedOptionId}
                                    onClick={() => onSelect(option.id)}
                                >
                                    {option.name}
                                </ExpandableSelectorItem>
                            ))}
                        </ExpandableSelectorList>
                    </div>
                )}
            </div>
        </ClickAwayListener>
    );
};

export default FilterDropdown;
